import Id from "./Id";

class DataModel {
  id?: Id;
}

export default DataModel;